module.exports = __webpack_public_path__ + "static/media/vert01.2f7c1815.glsl";